// @TODO <HEALTH2019>
App.controller('LifeWithPaymentsSummaryCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', '$timeout', 'dataUser', 'Blob', 'FileSaver', '$rootScope', 'lifeInsuranceWithPaymentsService', 'userInvitationService', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, $timeout, dataUser, Blob, FileSaver, $rootScope, lifeInsuranceWithPaymentsService, userInvitationService, popUpService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Podsumowanie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.list';
    $scope.$emit('link', $scope.link);

    $scope.newUserInvitationEmail = false;
    $scope.newUserInvitationEmails = [''];

    if (lifeInsuranceWithPaymentsService.isUnum()) {
        if ($stateParams.hasEnteredDeclaration) {
            popUpService.showPopUp({
                head: 'Uwaga',
                content: 'Nowo wypełniony wniosek zastąpił poprzednią wersję dokumentu. Opłacenie składki oznaczało będzie aktywację ubezpieczenia w oparciu o najnowszą wersję wniosku przystąpienia do ubezpieczenia.'
            });
        }
    }
    if (lifeInsuranceWithPaymentsService.isPzu()) {
        if ($stateParams.hasActiveDeclaration) {
            popUpService.showPopUp({
                head: 'Uwaga',
                content: 'Nowo wypełniona deklaracja zastąpi poprzednią wersję dokumentu, pod warunkiem dostarczenia podpisanej deklaracji do Xilium.'
            });
        } else if ($stateParams.hasEnteredDeclaration) {
            popUpService.showPopUp({
                head: 'Uwaga',
                content: 'Nowo wypełniona deklaracja zastąpiła poprzednią wersję dokumentu. Aby ochrona ubezpieczeniowa się rozpoczęła, należy dostarczyć do Xilium aktualną deklarację.'
            });
        }
    }

    profileService.dataUser().then(function (data) {
        $scope.userData = data.data;
    });

    $scope.addNewUserInvitationEmail = function () {
        if ($scope.newUserInvitationEmails.length < 10) {
            $scope.newUserInvitationEmails.push('');
        }
    };

    $scope.sendNewUserInvitationEmails = function () {
        var data = {
            emails: $scope.newUserInvitationEmails
        };
        userInvitationService.sendInvitations(data).then(function () {
            $scope.newUserInvitationEmails = [];
        });
    };
    lifeInsuranceWithPaymentsService.last().then(function (data) {
        if (data.status === 200) {
            var pkg = data.data;

            if (!pkg || !Object.keys(pkg).length) {
                $state.go('root.life.variant');
                return;
            }

            var names = [];
            var totalPrice = 0;
            pkg.main.lifeInsurances.forEach(function (single) {
                totalPrice += single.price;
                names.push(single.name);
            });

            $scope.price = totalPrice;
            $scope.proposedDate = pkg.main.proposedDate;
            $scope.barcode = pkg.main.barcode;
            $scope.uuid = pkg.main.uuid;
            $scope.packages = names;
            $scope.lifePartner = pkg.main.partner;
        }
    });

    $scope.bankAccountNumber = null;
    profileService.getBankAccountNumber('LIFE_INSURANCE').then(function (success) {
        if (success.data) {
            $scope.bankAccountNumber = success.data.accountNumber;
        }
    });

    $scope.downloadDeclaration = function (event, uuid) {
        var el = $(event.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(event.currentTarget).addClass('disabled');
        }

        popUpService.showPopUp({
            head: 'Pamiętaj!',
            content: 'Dokonywanie zmian długopisem na wydrukowanej deklaracji nie jest dopuszczalne – złóż jedynie swój podpis.',
            text: 'Pobierz deklarację'
        }).then(function () {
            lifeInsuranceWithPaymentsService.downloadDeclaration(uuid).then(
                function (success) {
                    if (success.status === 200) {
                        let blob = new Blob([success.data], {type: "application/pdf"});
                        let filename = $filter('getFileNameFromContentDisposition')(success.headers('Content-Disposition'));
                        FileSaver.saveAs(blob, filename ? filename : 'declaracja' + $scope.barcode + '.pdf');
                    }
                }
            ).finally(function () {
                $timeout(function () {
                    $(event.currentTarget).removeClass('disabled');
                }, 1000);
            });
        }).finally(function () {
            $timeout(function () {
                $(event.currentTarget).removeClass('disabled');
            }, 1000);
        });
        ;


    };
}]);
